export default {
  data() {
    return {
      provinceList: [],
      cityList: [],
      districtList: [],
      townList: [],
      baseService: "autoapp-default-server-recovery",
      rules: {
        goodsYardInfoReq: {
          goodsYardCode: [
            {
              required: true,
              message: "请输入货场编码",
              trigger: ["blur", "change"]
            }
          ],
          orgId: [
            {
              required: true,
              message: "请选择分公司",
              trigger: ["blur", "change"]
            }
          ],
          goodsYardUser: [
            {
              required: true,
              message: "请输入货场主姓名",
              trigger: ["blur", "change"]
            },
            {
              max: 10,
              message: "长度不能超过10个字符",
              trigger: ["blur", "change"]
            }
          ],
          goodsYardPhone: [
            {
              required: true,
              message: "请输入联系电话",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^\d{1,15}$/,
              message: "请输入15位以内数字",
              trigger: ["blur", "change"]
            }
          ],
          provinceCode: [
            { required: true, message: "请选择省", trigger: "change" }
          ],
          cityCode: [
            { required: true, message: "请选择市", trigger: "change" }
          ],
          districtCode: [
            { required: true, message: "请选择区", trigger: "change" }
          ],
          townCode: [
            { required: true, message: "请选择县", trigger: "change" }
          ],
          address: [
            {
              required: true,
              message: "请输入详细地址",
              trigger: ["blur", "change"]
            },
            {
              max: 50,
              message: "长度不能超过50个字符",
              trigger: ["blur", "change"]
            }
          ],
          goodsYardSquare: [
            {
              required: true,
              message: "请输入货场面积",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^[1-9]\d{0,9}$/,
              message: "请输入大于0的10位以内整数",
              trigger: ["blur", "change"]
            }
          ],
          monthNum: [
            {
              required: true,
              message: "请输入月供货量",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^(0|[1-9]\d{0,9})$/,
              message: "请输入大于等于0的10位以内整数",
              trigger: ["blur", "change"]
            }
          ],
          yearNum: [
            {
              required: true,
              message: "请输入年供货量",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^(0|[1-9]\d{0,9})$/,
              message: "请输入大于等于0的10位以内整数",
              trigger: ["blur", "change"]
            }
          ],
          businessCategory: [
            { required: true, message: "请选择经营情况", trigger: "change" }
          ]
        },
        goodsYardVisitReq: {
          visitDate: [
            {
              required: true,
              message: "请选择走访时间",
              trigger:["blur", "change"]
            }
          ],
          goodsYardInventory: [
            {
              required: true,
              message: "请输入货场库存",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^[1-9]\d{0,9}$/,
              message: "请输入大于0的10位以内整数",
              trigger: ["blur", "change"]
            }
          ],
          singleAirconditionRecyclePrice: [
            {
              required: true,
              message: "请输入单片回收价",
              trigger: ["blur", "change"]
            },
            {
              max: 10,
              message: "长度不能超过10个字符",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
              message: "请大于0且最多两位小数",
              trigger: ["blur", "change"]
            }
          ],
          doubleAirconditionRecyclePrice: [
            {
              required: true,
              message: "请输入双片回收价",
              trigger: ["blur", "change"]
            },
            {
              max: 10,
              message: "长度不能超过10个字符",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
              message: "请大于0且最多两位小数",
              trigger: ["blur", "change"]
            }
          ],
          singleAirconditionSellPrice: [
            {
              required: true,
              message: "请输入单片出货价",
              trigger: ["blur", "change"]
            },
            {
              max: 10,
              message: "长度不能超过10个字符",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
              message: "请大于0且最多两位小数",
              trigger: ["blur", "change"]
            }
          ],
          doubleAirconditionSellPrice: [
            {
              required: true,
              message: "请输入双片出货价",
              trigger: ["blur", "change"]
            },
            {
              max: 10,
              message: "长度不能超过10个字符",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
              message: "请大于0且最多两位小数",
              trigger: ["blur", "change"]
            }
          ],
          latestSupplyDate: [
            {
              required: true,
              message: "请选择最近供货时间",
              trigger: ["blur", "change"]
            }
          ],
          latestShipmentPlan: [
            {
              required: true,
              message: "请输近期出货计划",
              trigger: ["blur", "change"]
            },
            {
              max: 150,
              message: "长度不能超过150个字符",
              trigger: ["blur", "change"]
            }
          ],
          partnerMode: [
            {
              required: true,
              message: "请输入合作模式",
              trigger: ["blur", "change"]
            },
            {
              max: 150,
              message: "长度不能超过150个字符",
              trigger: ["blur", "change"]
            }
          ],
          sourceFlow: [
            {
              required: true,
              message: "请输入货源流向",
              trigger: ["blur", "change"]
            },
            {
              max: 150,
              message: "长度不能超过150个字符",
              trigger: ["blur", "change"]
            }
          ],
          cooperativeSuppliers: [
            {
              required: true,
              message: "请输入合作供应商",
              trigger: ["blur", "change"]
            },
            {
              max: 150,
              message: "长度不能超过150个字符",
              trigger: ["blur", "change"]
            }
          ]
        },
        goodsYardCompetitorsReqs: {
          competitorsName: [
            {
              required: true,
              message: "请输入竞企名称",
              trigger: ["blur", "change"]
            }
          ],
          singleAirconditionRecyclePrice: [
            {
              required: true,
              message: "请输入单片收货价",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^(0|[1-9]\d{0,9})(\.\d{1,2})?$/,
              message: "请大于0且最多两位小数",
              trigger: ["blur", "change"]
            },
            {
              max: 10,
              message: "长度不能超过10个字符",
              trigger: ["blur", "change"]
            }
          ],
          doubleAirconditionRecyclePrice: [
            {
              required: true,
              message: "请输入双片收货价",
              trigger: ["blur", "change"]
            },
            {
              pattern: /^(0|[1-9]\d{0,9})(\.\d{1,2})?$/,
              message: "请大于0且最多两位小数",
              trigger: ["blur", "change"]
            },
            {
              max: 10,
              message: "长度不能超过10个字符",
              trigger: ["blur", "change"]
            }
          ]
        }
      },
      businessCategory: {
        AIR_CONDITIONER: "空调",
        REFRIGERATOR: "冰箱",
        WASHING_MACHINE: "洗衣机",
        LED_TV: "液晶电视机",
        LCD_TV: "液晶显示器",
        HOST: "主机",
        LAPTOP: "笔记本",
        CRT_TV: "CRT电视机"
      }
    };
  },
  created() {
    this.getTblProvince();
  },
  methods: {
    // 获取省份列表
    getTblProvince() {
      const url = `${this.baseService}/api/tbl-recycel-engineer/province`;
      return this.HttpService.post(url).then(res => {
        if (res.statusCode === 200) {
          this.provinceList = res.data || [];
        }
      });
    },
    // 根据省份获取城市列表
    getTblCity(provinceCode) {
      const url = `${this.baseService}/api/tbl-recycel-engineer/city?provinceCode=${provinceCode}`;
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.cityList = res.data || [];
        }
      });
    },

    // 根据省市获取区域
    getTblCounty(cityCode) {
      const url = `${this.baseService}/api/tbl-recycel-engineer/district?cityCode=${cityCode}`;
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.districtList = res.data || [];
        }
      });
    },
    // 根据省市获取区获取县级
    getTblTown(districtCode) {
      const url = `${this.baseService}/api/tbl-recycel-engineer/town?districtCode=${districtCode}`;
      return this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.townList = res.data || [];
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/dataBoard/mixin.js